import request from '@/API/';

export default {
  saveVariable: (payload) => {
    return request.post(`editor/save?c=${payload.clientHash}&a=${payload.appHash}&i=${payload.interfaceHash}`, {
      ...payload.variables,
    });
  },
  getVariables: (payload) => {
    return request.get(`editor/app?c=${payload.clientHash}&a=${payload.appHash}&i=${payload.interfaceHash}`);
  },
};
